
import searchFormMixin from '@/mixins/search-form-mixin';
import staticId from '~/mixins/static-id';
import vClickOutside from 'v-click-outside';

export default {
    name: 'SearchFormCasa',
    mixins: [searchFormMixin, staticId],
    directives: {
        clickOutside: vClickOutside.directive
    },
    computed: {
        isClient() {
            return process.client;
        }
    },
    methods: {
        testClick({ target }) {
            if (target?.id === 'casa-open-search-button') {
                return;
            }
            this.closeModalAndClearSearch();
        },
        clearSearchHandler() {
            this.clearSearchValue();
            if (window.innerWidth <= 1024) {
                this.closeModalAndClearSearch();
            }
        }
    },
    watch: {
        async getModalShow(newVal) {
            if (newVal) {
                await this.updateBadges();
                document.body.classList.add('popup-open');
            } else {
                document.body.classList.remove('popup-open');
            }
        }
    }
};
